import './cartao-solicitar-controller';
import './cartao-consultar-controller';
import './cartao-confirmar-controller';
import './cartao-consultar-solicitacoes-controller';
import './motivo-rejeicao-controller';

